module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=NR - Nauru.80cf8000.svg";